import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ScheduledReportsRoutes: Routes = [
  {
    path: "scheduled-reports",
    loadComponent: () =>
      import("./scheduled-reports/scheduled-reports.component").then(
        (m) => m.ScheduledReportsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./scheduled-reports-list/scheduled-reports-list.component").then(
            (m) => m.ScheduledReportsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./scheduled-reports-form/scheduled-reports-form.component").then(
            (m) => m.ScheduledReportsFormComponent,
          ),
      },
      {
        path: ":reportId",
        loadComponent: () =>
          import("./scheduled-reports-list/scheduled-reports-list.component").then(
            (m) => m.ScheduledReportsListComponent,
          ),
      },
      {
        path: "view/:scheduleId",
        loadComponent: () =>
          import("./scheduled-reports-form/scheduled-reports-form.component").then(
            (m) => m.ScheduledReportsFormComponent,
          ),
      },
      {
        path: ":reportId/add",
        loadComponent: () =>
          import("./scheduled-reports-form/scheduled-reports-form.component").then(
            (m) => m.ScheduledReportsFormComponent,
          ),
      },
    ],
  },
];
